import React from 'react';

const IsLoading = () => {
    return (
        <div>
            Loading...
        </div>
    );
};

export default IsLoading;